<template>
  <div class="accept-invite-base">
    <header-base pageType='accept_invite'/>
  </div>
</template>

<script>
import HeaderBase from '@/components/HeaderBase'
import SessionsService from '@/services/SessionsService'
export default {
  name: 'accept-invite-base',
  data () {
    return {}
  },
  components: {
    HeaderBase
  },
  async created () {
    let sessionId = this.$route.params.id
    let authToken = this.$route.params.authToken

    let solver = localStorage.getItem('globalSolver')
    let solverId = localStorage.getItem('globalSolverId')
    let globalAuthToken = localStorage.getItem('globalAuthToken')
    if (globalAuthToken) {
      this.$store.commit('setSolver', solver)
      this.$store.commit('setSolverId', solverId)
      this.$store.commit('setGlobalAuthToken', globalAuthToken)

      let response = await SessionsService.acceptInvite(sessionId, authToken, {
        solver: solver,
        solverId: solverId,
        globalAuthToken: globalAuthToken
      })

      if (response.data.success === true) {
        this.$store.commit('setAuthToken', response.data.authToken)
        localStorage.setItem('solverId:' + this.$route.params.id, solverId)
        localStorage.setItem('token:' + this.$route.params.id, response.data.authToken)
        console.log(response.data)

        this.$router.push({ path: `/session/${sessionId}` })
      } else {
        alert('Error: ' + response.data.error)
      }
    } else {
      alert('You must be logged in to accept an invite')
    }
  }
}
</script>
